// (() => {
//   angular
//     .module('complianceFrameworkApp.socialMediaCompliance')
//     .config(routes);

//   /* ngInject */
//   function routes($stateProvider) {
//     $stateProvider
//       .state('application.social_media_compliance', {
//         abstract: true,
//         url: '/social_media_compliance',
//         views: {
//           '': { template: '<div ui-view></div>' },
//           'top-nav': {
//             templateUrl: '/templates/compliance_framework/layouts/top-nav.html',
//             controller: 'TopNavController',
//             controllerAs: 'topNavVm'
//           },
//           'side-nav': {
//             templateUrl: '/templates/social_media_compliance/layouts/side-nav.html',
//             controller: 'SocialMediaComplianceSideNavController',
//             controllerAs: 'sideNavVm'
//           }
//         }
//       })
//       ;
//   }
// })();
